import React from "react";
import { Button } from "aible";
import { useDispatch, useSelector } from "types/store";
import { isEnabled } from "utils/featureFlags";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCompressArrowsAlt, faExpandArrowsAlt } from "@fortawesome/free-solid-svg-icons";
import { getDataset } from "containers/Home/reducer";
import { WhatsChangedInput } from "@/components/ChatGPT/ChatGPT";
import KPIAnalysisSetup from "@/components/Templates/KPIAnalysisSetup";
import * as nextReducer from "containers/Next/NextReducer";
import * as homeReducer from "containers/Home/reducer";
import styles from "./style.module.css";
import { updateTileState } from "containers/Sense/reducer";
import { getIsOpenKpiWhatsChangedOptions } from "@/containers/Sense/dataset-selectors";
const KpiWhatsChangedOptions = ({ datasetId }) => {
    const dispatch = useDispatch();
    const dataset = useSelector((state) => getDataset(state, datasetId));
    const isOpen = useSelector((state) => getIsOpenKpiWhatsChangedOptions(state, datasetId));
    const updateIsOpen = (isOpenKpiWhatsChangedOptions) => {
        dispatch(updateTileState(datasetId, { isOpenKpiWhatsChangedOptions }));
    };
    const isSavingKPIAnalysis = useSelector((state) => homeReducer.getIsSavingKPIAnalysis(state, datasetId));
    const timeBucket = useSelector((state) => homeReducer.getKPIAnalysisTimeBucket(state, datasetId));
    const comparisonOptions = useSelector((state) => nextReducer.getComparisonOptions(state, "DATASET_" + datasetId));
    const dateField = comparisonOptions?.dateField;
    const isProcessing = dataset?.status_name !== "DONE";
    const isError = dataset?.dataset_status === "ERROR";
    let fields = dataset?.ranked_fields;
    if (!fields && dataset?.fields) {
        fields = Object.keys(dataset.fields).map((fKey) => dataset.fields[fKey]);
    }
    const dateFieldOptions = fields !== undefined
        ? fields
            .filter((f) => f.type === "date")
            .map((f) => ({
            value: f,
            label: f.label
        }))
        : [];
    const isDisabled = !(isEnabled("dataset-whats-changed") || isEnabled("test-train-split")) ||
        isError ||
        isProcessing ||
        dataset?.number_of_rows === undefined ||
        dataset?.number_of_rows === -1 ||
        dateFieldOptions.length === 0;
    if (isDisabled) {
        return React.createElement(React.Fragment, null);
    }
    return (React.createElement("div", { id: "kpiWhatsChangedSetupSection" + dataset?.id, className: isOpen ? styles.openOverview : styles.overview, style: {
            width: "calc(100% - 20px)",
            position: "relative"
        }, onClick: !isOpen ? () => updateIsOpen(!isOpen) : undefined },
        React.createElement("div", { className: styles.senseTitle, style: { alignItems: "center", lineHeight: "16px" } },
            React.createElement("div", { className: styles.sTitle }, "What's Changed Settings"),
            isOpen ? (React.createElement("div", { id: "kpiWhatsChangedSetupSectionClose_" + dataset?.id, className: styles.closeButton, onClick: () => updateIsOpen(!isOpen) },
                React.createElement(Button, { style: { padding: "3px" } },
                    React.createElement("div", { className: styles.selIcon, title: "Close" },
                        React.createElement(FontAwesomeIcon, { icon: faCompressArrowsAlt }))))) : (React.createElement("div", { className: styles.expandIcon },
                React.createElement("div", { className: styles.selIcon },
                    React.createElement(FontAwesomeIcon, { icon: faExpandArrowsAlt }))))),
        isOpen && (React.createElement("div", { className: styles.kpiWhatsChangedContent },
            React.createElement(WhatsChangedInput, { senseDatasetId: datasetId, isManualApply: false }),
            dateField && timeBucket && !isSavingKPIAnalysis && React.createElement(KPIAnalysisSetup, { senseDatasetId: datasetId })))));
};
export default KpiWhatsChangedOptions;
